import React from "react";

const MobileReservations = () => {
    return (
        <div className="reservations" id="mobile-reservations">
            <h1>Reservations</h1>
            <p>
                For bookings aute aliqua ex quis in veniam quis duis occaecat ex
                fugiat esse culpa incididunt non. Quis ullamco commodo laboris
                aliqua magna occaecat ut sint ex minim velit ut
            </p>

            <p>
                Pariatur quis irure dolore adipisicing esse est tate
                (043)-123-4567.
            </p>
        </div>
    );
};

export default MobileReservations;
